import { useSelector } from "react-redux";
import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useEffect, useState } from "react";
import { getCompanyInfo, setCompanyInfoValues, setEditableCompanyInfo, updateCompanyInfo } from "../../features/companyProfile/companyProfileSlice";
import InputNumberNew from "../../components/shared/input/new/InputNumberNew";
import InputText from "../../components/shared/input/new/InputText";
import InputSelect from "../../components/shared/input/new/InputSelect";
import InputCityTown from "../../components/shared/input/new/InputCityTown";
import InputIban from "../../components/shared/input/new/InputIban";
import InputPassword from "../../components/shared/input/new/InputPassword";
import { useDispatch } from "react-redux";
import question from "../../images/svg/question.svg"
import Btn from "../../components/shared/button/Btn";
import { BsPencilSquare } from "react-icons/bs";
import TopMenus from "../../components/shared/TopMenus";
import { GoQuestion } from "react-icons/go";
import { showModal, showNestedModal } from "../../features/modal/modalSlice";
import InputPhoneFormat from "../../components/shared/input/new/InputPhoneFormat";
import InputTextarea from "../../components/shared/input/new/InputTextarea";
import useWindowDimensions from "../../hooks/useWindowSize";


const Container = styled.div`
  width: 100%;
  .wrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: 100px;
    width: 100%;

    .top-side{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 30px 30px 0px 30px;
        padding-bottom: 30px;
        border-bottom: 1px solid;
        border-color:  ${({ theme }) => theme.mainBorderColor};

        svg{
            margin-right: 5px;
        }
        .logo-container{
            display: flex;
            align-items: center;
            .logo{
                margin-right: 10px;
                border: 1px solid;
                border-color:  ${({ theme }) => theme.mainBorderColor};
                border-radius: 8px;
                width: 100px;
                height: 100px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .name{
                display: flex;
                flex-direction: column;
                gap: 5px;
                color: ${({ theme }) => theme.mainTextColor} !important;
                p{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                    
                }
                span{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-sm);
                }
            }
        }
        .operations{
            .btn-container{
                display: flex;
                align-items: center;
                gap: 15px;
            }
        }
        
    }
    .info-container{
        width: 70%;
        display: flex;
        justify-content: space-between;
        gap: 15px;
        margin: 30px;
        .col{
            display: flex;
            flex-direction: column;
            width: 50%;
            gap: 15px;
            .row{
                display: flex;
                align-items: center;
                gap: 10px;
                svg{
                    font-size: 20px;
                    margin-left: 10px;
                    cursor: pointer;
                }
            }
            .text-container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                padding: 5px;
                background-color: ${({ theme }) => theme.mainBgColor} !important;
                p{
                    min-width: 145px;
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                }
                span{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    text-align: end;
                }
            }
        }
        
    }
  }

  @media(max-width: 1250px){

    .info-container{
        width: calc(100% - 60px) !important;
    }

  }

  @media(max-width: 950px){

    .info-container{
        flex-direction: column;

        .col{
            width: 100% !important;
        }
    }

    .btn-container{
        flex-direction: column;
    }

}



`;

const kolayAdresTypes = [
  {
      id: 1,
      text: "TC No"
  },
  {
      id: 2,
      text: "Telefon"
  },
  {
      id: 3,
      text: "Vergi No"
  },
  {
      id: 4,
      text: "Mail"
  },
]

const FirmaBilgileri = () => {

    const dispatch = useDispatch()
    const {theme} = useSelector((state) => state.layout)

    const {windowDimensions} = useWindowDimensions()

    const [isShow, setIsShow] = useState(false)
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

    const {companyInfoValues, companyProfileInfo, isEditableCompanyInfo, topBarCompanyInfo} = useSelector((state) => state.companyProfile)
    const {companyTaxNo, companyVergiDairesi, companyName, companyShortName, companyPhoneNumber, companyMail, companyAddress, companyCityTown, companyLocation, billTitle, bankAccountOwner, bankIBANNo, kolayAdresType, kolayAdres, gibUsername, gibPassword} = companyInfoValues
    const [phoneValue, setPhoneValue] = useState("")

    useEffect(() => {
        dispatch(getCompanyInfo())
    },[])

    useEffect(() => {
        dispatch(setCompanyInfoValues(companyProfileInfo))
    },[companyProfileInfo])

    const handleChange = (e) => {
        dispatch(setCompanyInfoValues({...companyInfoValues, [e?.target?.name]: e?.target?.value}))
    }

    const handleSelectIlIlce = (data) => {
        dispatch(setCompanyInfoValues({...companyInfoValues, companyCityTown: data}))
    }

    const handleSelectKolayAdresType = (data) => {
        dispatch(setCompanyInfoValues({...companyInfoValues, kolayAdresType: data}))
    }

    const showPassword = () => {
        setIsShow((prev) => !prev)
    }


    useEffect(() => {
        if (companyPhoneNumber) {
            const formattedPhoneNumber = (companyPhoneNumber.startsWith("+90") || companyPhoneNumber.startsWith("90")) ? `${companyPhoneNumber}` : `90${companyPhoneNumber}`;
            setPhoneValue(formattedPhoneNumber);
        }
      }, [isEditableCompanyInfo]);

    useEffect(() => {
        dispatch(setCompanyInfoValues({...companyInfoValues, companyPhoneNumber: phoneValue}))
    }, [phoneValue])

    const handleUpdate = () => {
        const updateValues = {
            companyTaxNo: companyTaxNo || "",
            companyVergiDairesi: companyVergiDairesi || "",
            companyName: companyName || "",
            companyShortName: companyShortName || "",
            companyPhoneNumber: companyPhoneNumber?.slice(2) || "",
            companyMail: companyMail || "",
            companyAddress: companyAddress || "",
            companyCityTown: (companyCityTown?.location || companyCityTown ) || "",
            companyLocation: companyLocation || "",
            billTitle: billTitle || "",
            bankAccountOwner: bankAccountOwner || "",
            bankIBANNo: bankIBANNo || "",
            kolayAdresType: (kolayAdresType?.text || kolayAdresType) || "",
            kolayAdres: kolayAdres || "",
            gibUsername: gibUsername || "",
            gibPassword: gibPassword || "",
            firmaType: companyProfileInfo?.firmaType,
            firmaTypeId: companyProfileInfo?.firmaTypeId,
            id: companyProfileInfo?.id
        }
        
        dispatch(updateCompanyInfo(updateValues))
    }

    
  return (
    <Container theme={theme}>
      <div className="wrapper">
        {
            windowDimensions.width > 850 &&
            <PageTopTitle title={"Firma Bilgileri"} position="sticky" top="210px" />
        }

        <div className="top-side">
            <div className="logo-container">
                <div className="logo">
                    <img src={(topBarCompanyInfo?.logo1 || topBarCompanyInfo?.logo2) ? (`${process.env.REACT_APP_API_IMG_COMPANY_URI}${topBarCompanyInfo?.logo1}` || `${process.env.REACT_APP_API_IMG_COMPANY_URI}${topBarCompanyInfo?.logo2}` ) : question} alt="" />
                </div>
                <div className="name">
                    <p>{companyProfileInfo?.companyName}</p>
                    {companyProfileInfo?.firmaTypeId === 1 && <span>Dijital Lojistikçi</span>}
                    {companyProfileInfo?.firmaTypeId === 2 && <span>Kooperatif</span>}
                    {companyProfileInfo?.firmaTypeId === 3 && <span>Yük Veren</span>}
                    {companyProfileInfo?.firmaTypeId === 4 && <span>Yük Veren</span>}
                </div>
            </div>
            <div className="operations">
            {
                isEditableCompanyInfo ?
                <div className="btn-container">
                    <Btn handleClick={() => {dispatch(setEditableCompanyInfo()); }} color="#E85446" bgColor="transparent" height={windowDimensions.width  > 700 ? "40px" : "33px"} width={windowDimensions.width  > 700 ? "140px" : "80px"}>İptal</Btn>
                    <Btn handleClick={() => {dispatch(handleUpdate)}} color="#E85446" bgColor="transparent" height={windowDimensions.width  > 700 ? "40px" : "33px"} width={windowDimensions.width  > 700 ? "140px" : "80px"}>Kaydet</Btn>
                </div>
                :
                <Btn handleClick={() => dispatch(setEditableCompanyInfo())} color="#E85446" bgColor="transparent" fontSize={windowDimensions.width  > 700 ? "14px" : "12px"} height={windowDimensions.width  > 700 ? "40px" : "33px"} width={windowDimensions.width  > 700 ? "140px" : "120px"}><BsPencilSquare />Profili Düzenle</Btn>
            }
            </div>
        </div>

        <div className="info-container">
            {
                isEditableCompanyInfo ? 
                <div className="col">
                    <InputText data={companyVergiDairesi} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyVergiDairesi" labelText='Firma Vergi Dairesi' /> 
                    <InputNumberNew disabled={true} data={companyTaxNo} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyTaxNo" labelText='Firma Vergi No' />
                    
                    <InputText data={companyName} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyName" labelText='Firma Adı / Ünvanı' /> 
                    <InputText data={companyShortName} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyShortName" labelText='Firma Kısa Adı' /> 
                    
                    {/* <InputNumberNew data={companyPhoneNumber} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyPhoneNumber" labelText='Firma Telefonu' />  */}
                    <InputPhoneFormat data={phoneValue} setData={setPhoneValue} inputWidth={"100%"} name="companyPhoneNumber" labelText='Firma Telefonu' /> 
                    <InputText data={companyMail} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyMail" labelText='Firma Mail Adresi' />
                    
                    <InputTextarea data={companyAddress} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyAddress" labelText='Firma Adresi' /> 
                    <InputCityTown data={companyCityTown?.location} setData={handleSelectIlIlce} inputWidth={"100%"} name={"companyCityTown"} labelText="Firma İl/İlçe" />
                    <div className="row">
                        <InputTextarea disabled={true} data={companyLocation} setData={(e) => handleChange(e)} inputWidth={"100%"} name="companyLocation" labelText='Firma Lokasyonu' />
                        <Btn handleClick={() => dispatch(showNestedModal("firmaBilgileriSelectMap"))} padding="0px 10px" color="#E85446" bgColor="transparent" fontSize={windowDimensions.width <= 700 && "10px"} width={windowDimensions.width  > 700 ? "200px" : "min-content"}>Haritadan Konum Seç</Btn>
                    </div>
                    
                </div>
                :
                <div className="col">
                    <div className="text-container">
                        <p>Firma Vergi Dairesi:</p>
                        <span>{companyProfileInfo?.companyVergiDairesi ? companyProfileInfo?.companyVergiDairesi : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma Vergi No:</p>
                        <span>{companyProfileInfo?.companyTaxNo ? companyProfileInfo?.companyTaxNo : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma Adı / Ünvanı:</p>
                        <span>{companyProfileInfo?.companyName ? companyProfileInfo?.companyName : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma Kısa Adı:</p>
                        <span>{companyProfileInfo?.companyShortName ? companyProfileInfo?.companyShortName : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma Telefonu:</p>
                        <span>{companyProfileInfo?.companyPhoneNumber ? companyProfileInfo?.companyPhoneNumber : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma Mail Adresi:</p>
                        <span>{companyProfileInfo?.companyMail ? companyProfileInfo?.companyMail : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma Adresi:</p>
                        <span>{companyProfileInfo?.companyAddress ? companyProfileInfo?.companyAddress : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma İl/İlçe:</p>
                        <span>{companyProfileInfo?.companyCityTown ? companyProfileInfo?.companyCityTown : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Firma Lokasyonu:</p>
                        <span>{companyProfileInfo?.companyLocation ? companyProfileInfo?.companyLocation : "-"}</span>
                    </div>
                    
                </div>
            }

            {
                isEditableCompanyInfo ? 
                <div className="col">
                    <InputTextarea data={billTitle} setData={(e) => handleChange(e)} inputWidth={"100%"} name="billTitle" labelText='Fatura Başlığı' /> 
                    <InputText data={bankAccountOwner} setData={(e) => handleChange(e)} inputWidth={"100%"} name="bankAccountOwner" labelText='Banka Hesap Sahibi' /> 
                    <InputIban data={bankIBANNo} setData={(e) => handleChange(e)} inputWidth={"100%"} name="bankIBANNo" labelText='Banka IBAN No' borderColor="mainBorderColor" />
                    <InputSelect initialOptions={kolayAdresTypes} data={kolayAdresType?.text} setData={handleSelectKolayAdresType} inputWidth={"100%"} name="kolayAdresType" labelText='Hesap Kolay Adres Türü' /> 
                    <InputText data={kolayAdres} setData={(e) => handleChange(e)} inputWidth={"100%"} name="kolayAdres" labelText='Hesap Kolay Adres' /> 
                    <div className="row">
                        <InputText auto={"off"} data={gibUsername} setData={(e) => handleChange(e)} inputWidth={"100%"} name="gibUsername" labelText='GİB Portal Kullanıcı Adı' />
                        <GoQuestion onClick={() => dispatch(showModal("gibInfo"))} />
                    </div>
                    <InputPassword auto="new-password" data={gibPassword} setData={(e) => handleChange(e)} inputWidth={"100%"} name="gibPassword" labelText='GİB Portal Şifresi' type={isShow ? "text" : "password"} isShow={isShow} showPassword={showPassword} /> 
                </div>
                :
                <div className="col">
                    <div className="text-container">
                        <p>Fatura Başlığı:</p>
                        <span>{companyProfileInfo?.billTitle ? companyProfileInfo?.billTitle : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Banka Hesap Sahibi:</p>
                        <span>{companyProfileInfo?.bankAccountOwner ? companyProfileInfo?.bankAccountOwner : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Banka IBAN No:</p>
                        <span>TR {companyProfileInfo?.bankIBANNo ? companyProfileInfo?.bankIBANNo : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Hesap Kolay Adres Türü:</p>
                        <span>{companyProfileInfo?.kolayAdresType ? companyProfileInfo?.kolayAdresType : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>Hesap Kolay Adres:</p>
                        <span>{companyProfileInfo?.kolayAdres ? companyProfileInfo?.kolayAdres : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>GİB Portal Kullanıcı Adı:</p>
                        <span>{companyProfileInfo?.gibUsername ? companyProfileInfo?.gibUsername : "-"}</span>
                    </div>
                    <div className="text-container">
                        <p>GİB Portal Şifresi:</p>
                        <span>{companyProfileInfo?.gibPassword ? companyProfileInfo?.gibPassword : "-"}</span>
                    </div>
                </div>
            }
        </div>
      </div>
    </Container>
  );
};

export default FirmaBilgileri;
